'use strict';

angular.module('propertyController', [])
.controller('PropertyController', ['appInfo', '$scope', '$rootScope', '$window', '$log', '$q', '$routeParams', 'PropertyService',
    function (appInfo, $scope, $rootScope, $window, $log, $q, $routeParams, PropertyService) {    
    
    $rootScope.header.style = "collapse";
    $rootScope.header.show = false;
    $rootScope.loading = true;

    //Check auth credentials
    var currentUser = $rootScope.currentUser
    , ekey = currentUser.authdata
    , today = appInfo.today
    ;

   
    var id = ($routeParams.id)? $routeParams.id : 0;

    $scope.property = {};

    PropertyService.getProperty(id).then(function(rs) {
        var temp = {}

        switch($routeParams.state) {
            case('sold'):
                temp.state = 'Sold';
                break;
            case('listing'):
                temp.state = 'For Sale';
                break;
            case('auction'):
                temp.state = 'Auction';
                break;
            default:
                temp.state = 'For Sale';
        }
       
        if(rs[0].showAddress == "1"){
            temp.address = (rs[0].streetUnit!="")? 
                rs[0].streetUnit+"/"+rs[0].streetRef+" "+rs[0].streetName+" "+rs[0].streetType :
                rs[0].streetRef+" "+rs[0].streetName+" "+rs[0].streetType;
        }

        temp.agency = rs[0].agency[0];

        temp.suburb = rs[0].locationName;
        temp.priceView = rs[0].priceView;

        // Images --
        var images  = rs[0].marketing[0].images;
        temp.images = [];

        if(typeof images.img != 'undefined' && images.img.length){
            angular.forEach(images.img, function(image){
                temp.images.push(image);
            }); 
        } else {
            temp.images.push("http://dummyimage.com/800x533&text=Wiseberry");
        }

        temp.mainImg = temp.images[0];
        temp.activeImage = 0;
        
        // Heading & Description --
        temp.desc = rs[0].marketing[0].detail;
        temp.heading = rs[0].marketing[0].heading;

        $scope.property = temp;

        $window.scrollTo(0, angular.element('.property').offsetTop); 

        $rootScope.loading = false; 

    });

}]);